// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modal_modalContainer__9vHTm","modalTitle":"modal_modalTitle__9WQfu","modalDescription":"modal_modalDescription__VfY6D","modalXButton":"modal_modalXButton__WIqg1"};